import type { AccountSubscription } from '@frameio/graphql-client/generated';

export const getIsStorageAddOnIncluded = (
  addOns?: AccountSubscription['addOns']
): boolean =>
  addOns?.some((addOn) => addOn.modifier === 'storage_limit') ?? false;
